export default "__VITE_ASSET__OZfIZhGi__"